import {
  SERVICE_PROVIDER_PROFILE_LOADER,
  SERVICE_PROVIDER_LIST_LOADER,
  SET_ERROR_SERVICE_PROVIDER,
  SET_SERVICE_PROVIDER,
  SET_SERVICE_PROVIDERS_LIST,
  SET_SERVICE_PROVIDER_WIDGET,
  SET_SERVICE_PROVIDER_WIDGET_LOADER,
  SET_SERVICE_PROVIDER_DATE,
  SET_SERVICE_PROVIDER_RESULT
} from "./actionTypes";

const date = new Date();

const INIT_STATE = {
  data: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: [],
  },
  serviceProviderWidgets: [
    {
      icon: "bx bx-wallet-alt",
      title: "Payment",
      value: 0,
    },
    {
      icon: "bx bx-money",
      title: "Cost",
      value: 0,
    },
    {
      icon: "mdi mdi-cash-plus",
      title: "Cashback",
      value: 0,
    },
  ],
  serviceProviderStats: {
    results: [],
  },
  defDate: {
    start_date: new Date(date.getFullYear(), date.getMonth(), 1 + 1)
      .toJSON()
      .split("T")[0],
    end_date: new Date(date.getFullYear(), date.getMonth() + 1, 0 + 1)
      .toJSON()
      .split("T")[0],
  },
  profileData: {},
  profileLoader: false,
  isError: false,
  loading_list: false,
  loading_profile: false,
  serviceProviderWidgetsLoader: false,
  error: null,
};

const ServiceProviders = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_SERVICE_PROVIDERS_LIST:
      return {
        ...state,
        data: action.payload,
      };
    case SERVICE_PROVIDER_PROFILE_LOADER:
      return {
        ...state,
        loading: !state.loading_profile,
      };
    case SERVICE_PROVIDER_LIST_LOADER:
      return {
        ...state,
        loading_list: !state.loading_list,
      };
    case SET_SERVICE_PROVIDER:
      return {
        ...state,
        profileData: action.payload,
      };
    case SET_ERROR_SERVICE_PROVIDER:
      return {
        ...state,
        isError: action.payload,
      };
    case SET_SERVICE_PROVIDER_WIDGET: {
      return {
        ...state,
        serviceProviderWidgets: action.payload,
      };
    }
    case SET_SERVICE_PROVIDER_WIDGET_LOADER: {
      return {
        ...state,
        serviceProviderWidgetsLoader: !state.serviceProviderWidgetsLoader,
      };
    }
    case SET_SERVICE_PROVIDER_DATE:
      return {
        ...state,
        defDate: action.payload,
      };
    case SET_SERVICE_PROVIDER_RESULT:
      return {
        ...state,
        serviceProviderStats: action.payload,
      }
    default:
      return state;
  }
};

export default ServiceProviders;
